import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { LocalStorageKeys } from "@/components/pages/login/hooks/useLocalStorage";

export function resolveAdminTenantId(
  searchParams: URLSearchParams,
): string | undefined {
  const tenantIdFromUrl = searchParams.get("tenantId") || undefined;
  return (
    tenantIdFromUrl ??
    (typeof window !== "undefined"
      ? localStorage.getItem(LocalStorageKeys.TENANT_ID) || undefined
      : undefined)
  );
}

export function useAdminTenantId(): string | undefined {
  const [searchParams] = useSearchParams();
  return useMemo(() => resolveAdminTenantId(searchParams), [searchParams]);
}
